/**
 * Used for testing purposes, just a copy/paste from Drupals generated
 */
export default {
  'strings': {
    '': {
      'Home': 'Hjem',
      'Edit': 'Redig\u00e9r',
      'Open': '\u00c5ben',
      'Close': 'Luk',
      'Show': 'Vis',
      'Select all rows in this table': 'V\u00e6lg alle r\u00e6kker i tabellen',
      'Deselect all rows in this table': 'Frav\u00e6lg alle r\u00e6kker i tabellen',
      'Extend': 'Udvid',
      'Changed': '\u00c6ndret',
      'Please wait...': 'Vent venligst\u2026',
      'Hide': 'Skjul',
      '@label': '@label',
      'This permission is inherited from the authenticated user role.': 'Denne tilladelse er arvet fra den godkendte brugerrolle.',
      'An AJAX HTTP error occurred.': 'Der opstod en AJAX HTTP-fejl.',
      'HTTP Result Code: !status': 'HTTP resultatkode: !status',
      'An AJAX HTTP request terminated abnormally.': 'En AJAX HTTP-foresp\u00f8rgsel afsluttede p\u00e5 unormal vis.',
      'Debugging information follows.': 'Information til fejls\u00f8gning f\u00f8lger.',
      'Path: !uri': 'Sti: !uri',
      'StatusText: !statusText': 'StatusText: !statusText',
      'ResponseText: !responseText': 'ResponseText: !responseText',
      'ReadyState: !readyState': 'ReadyState: !readyState',
      'Collapse': 'Klap sammen',
      'Show all columns': 'Vis alle kolonner',
      'Show table cells that were hidden to make the table fit within a small screen.': 'Vis tabelceller som var skjult for at f\u00e5 tabellen til at passe p\u00e5 en lille sk\u00e6rm.',
      'List additional actions': 'Vis yderligere handlinger',
      'Horizontal orientation': 'Horisontal placering',
      'Vertical orientation': 'Vertikal placering',
      'Tray orientation changed to @orientation.': 'Bakkeplacering \u00e6ndret til @orientation.',
      '@action @title configuration options': 'Indstillinger for @action @title',
      'Tabbing is no longer constrained by the Contextual module.': 'Tabbing er ikke l\u00e6ngere begr\u00e6nset af Contextual-modulet.',
      'Tabbing is constrained to a set of @contextualsCount and the edit mode toggle.': 'Tabbing er begr\u00e6nset af @contextualsCount og redigeringstilstanden.',
      'Press the esc key to exit.': 'Tryk p\u00e5 esc for at afslutte.',
      '@count contextual link\u0003@count contextual links': '@count kontekstuelt link\u0003@count kontekstuellle links',
      'The toolbar cannot be set to a horizontal orientation when it is locked.': 'V\u00e6rkt\u00f8jslinjen kan ikke s\u00e6ttes til horisontal orientering n\u00e5r den er l\u00e5st.',
      'My booking': 'Min booking',
    },
  },
  'pluralFormula': {
    '1': 0,
    'default': 1,
  },
};
